<script setup lang="ts">
import { useDictionary } from '@autobid/ui/composables/useDictionary'
import SearchFormEcoItem from './SearchFormEcoItem.vue'

interface Props {
  dictionary: string
  label: string
}

const props = defineProps<Props>()

const { dictionary: entireDictionary, suspense } = useDictionary({ type: 'full' })
onServerPrefetch(suspense)

const item = computed(() => entireDictionary.value?.[props.dictionary])
</script>

<template>
  <div class="flex w-full flex-col gap-4">
    <p class="text-lg font-semibold text-primary">
      {{ label }}
    </p>
    <div class="grid w-full grid-cols-12 gap-4">
      <SearchFormEcoItem
        v-for="option in item?.options || []"
        :key="option.id"
        :group-key="dictionary"
        :option="option"
      />
    </div>
  </div>
</template>
